<template>
  <section class="hero is-fullheight">
    <div class="hero-body">

      <div class="container has-text-centered">
        <h1>Sleep Here</h1>
      </div>

    </div>
  </section>
</template>

<script>

console.log('hello, SleepingPage')

export default {
  name: 'SleepingPage'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/sleeping/SleepingPage.vue